import { render, staticRenderFns } from "./applyforcard.vue?vue&type=template&id=60852486&scoped=true&"
import script from "./applyforcard.vue?vue&type=script&lang=js&"
export * from "./applyforcard.vue?vue&type=script&lang=js&"
import style0 from "@/assets/components.scss?vue&type=style&index=0&id=60852486&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60852486",
  null
  
)

export default component.exports